"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.network = exports.SPKZ = void 0;
require("reflect-metadata");
const tsyringe_1 = require("tsyringe");
const proxyWalletService_1 = require("./services/proxyWalletService/proxyWalletService");
const roomService_1 = require("./services/roomService/roomService");
const roomsService_1 = require("./services/roomsService/roomsService");
const payloadService_1 = require("./services/payloadService/payloadService");
const metamaskService_1 = require("./services/metamask/metamaskService");
const network_enum_1 = require("../../models/network.enum");
Object.defineProperty(exports, "network", { enumerable: true, get: function () { return network_enum_1.network; } });
const bouncerService_1 = require("./services/bouncerService/bouncerService");
const environementService_1 = require("../utils/services/environmentService/environementService");
const fetchRoomService_1 = require("../utils/services/fetchRoomService/fetchRoomService");
const rightService_1 = require("../utils/services/rightService/rightService");
class SPKZ {
    constructor() {
        this.container = tsyringe_1.container.createChildContainer();
        this.wallets = this.container.resolve(proxyWalletService_1.ProxyWalletService);
        this.room = this.container.resolve(roomService_1.RoomService);
        this.bouncer = this.container.resolve(bouncerService_1.BouncerService);
        this.environmentService = this.container.resolve(environementService_1.EnvironmentService);
        this.rooms = this.container.resolve(roomsService_1.RoomsService);
        this.payloadService = this.container.resolve(payloadService_1.PayloadService);
        this.metamaskService = this.container.resolve(metamaskService_1.MetamaskService);
        this.fetchRoomService = this.container.resolve(fetchRoomService_1.FetchRoomService);
        this.rightService = this.container.resolve(rightService_1.RightService);
        this.checkAuthorizations = this.wallets.checkBlockchainWalletAuthorizations;
    }
    get privateKey() {
        return this.wallets.privateKey;
    }
}
exports.SPKZ = SPKZ;
SPKZ.fromPrivateKey = (privateKey) => {
    const spkzInstance = new SPKZ();
    spkzInstance.wallets.privateKey = privateKey;
    return spkzInstance;
};
//# sourceMappingURL=index.js.map